// Theme configuration for Hidatsa Áabaci website
// Use these constants throughout the app for consistent styling

// Primary brand colors
export const PRIMARY_COLOR = "#17405d"    // Dark blue - main brand color
export const SECONDARY_COLOR = "#246899"  // Lighter blue - secondary/hover states

// Additional theme colors
export const ACCENT_RED = "#E53E3E"       // Chakra red.500 equivalent
export const ACCENT_TEAL = "#319795"      // Chakra teal.500 equivalent

// Background colors
export const BG_LIGHT = "#EDF2F7"         // Light mode background
export const BG_DARK = "#1A202C"          // Dark mode background

// Text colors
export const TEXT_LIGHT = "#2D3748"       // Light mode text
export const TEXT_DARK = "#E2E8F0"        // Dark mode text

// Gradient presets
export const GRADIENTS = {
    primary: `linear(to-r, ${PRIMARY_COLOR}, ${SECONDARY_COLOR})`,
    hero: "linear(to-r, blackAlpha.500, transparent)",
    card: `linear(to-br, ${PRIMARY_COLOR}, ${SECONDARY_COLOR})`,
}

// Shadow presets
export const SHADOWS = {
    card: "0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)",
    cardHover: "0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)",
}

// Spacing presets for consistent layouts
export const SPACING = {
    section: { base: 8, md: 16 },
    container: { base: 4, md: 8 },
}

// Breakpoint values (matching Chakra defaults)
export const BREAKPOINTS = {
    sm: "30em",   // 480px
    md: "48em",   // 768px
    lg: "62em",   // 992px
    xl: "80em",   // 1280px
    "2xl": "96em" // 1536px
}
